<template>
    <div>
        <psp-errors-filter :action="filterAction"></psp-errors-filter>
        <kt-datatable v-if="$can('read', 'transaction')" v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
    </template>
<script>

import PspErrorsFilter from "./psp-errors-filter";
import columns from "../datatable/columns";
import {ApiUrl} from "../../../common/api.service";
import {AuthorizationHeader} from "../../../common/jwt.service";

export default {
    name: "psp_errors",
    props: {
        call_starshop: {
            required: false,
            type: Boolean,
            default: false
        },  
    },
    components: {
        PspErrorsFilter
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "psp_errors_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.call_starshop ? ApiUrl.starshopPath('transaction-routing/admin/psp-errors') : ApiUrl.path('transaction-routing/admin/psp-errors'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
            }
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
    }
}
</script>
<style scoped>
</style>